
import { zip } from "three/examples/jsm/libs/fflate.module";

type buffetype = ArrayBuffer | Uint8Array | Uint32Array | Uint16Array

// ex) const buffer = new Uint8Array([0,1,2,3,]);
// new ZipCompression(buffer, 9).compress().then((data) => {
// // 圧縮されたデーター　data　を取得
// download(data); // dataのダウンロード
// })
export class ZipCompression {

    private level: {level: number};

    //デフォルトの圧縮レベルは6
    constructor(private data: buffetype, private filename: string, level_: number = 6) {
        this.level = {level: level_};
    }

    public compress() {
        return new Promise((resolve_, reject_) => {
                const changeUnit8Array = () => {
                    if (this.data instanceof Uint8Array) return this.data;
                    let fileContent: Uint8Array = new Uint8Array();
                    if (this.data instanceof ArrayBuffer) fileContent = new Uint8Array(this.data);
                    if (this.data instanceof Uint16Array) fileContent = new Uint8Array(this.data.buffer);
                    if (this.data instanceof Uint32Array) fileContent = new Uint8Array(this.data.buffer);
                    return fileContent;
                }
                new Promise((resolve, reject) => {
                    const res = (err, data) => {
                        if (err) {
                            reject(err);
                        }
                        resolve(data);
                    };
                    const fileContent: Uint8Array = changeUnit8Array();
                    const obj = {[this.filename]: fileContent};
                    zip(obj, this.level, res);
                }).then((data: Uint8Array) => {
                    return resolve_(data);
                });
        }).catch((error) => {
            console.error(error);
        });
    }
}